let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Lmw8")).then(() => parcelRequire('dY9zr'));